import axios from '@/plugins/axios'
import { Module } from 'vuex'

const notificationModule: Module<any, any> = {
    actions: {
        async getEmailNotifications(_, params) {
            const page = params?.page ? '?page=' + params.page : ''
            const perPage = params?.perPage
                ? '&itemPerPage=' + params.perPage
                : ''
            const workspaceMemberId = params?.workspaceMemberId
                ? '&workspaceMemberId=' + params.workspaceMemberId
                : ''
            const emailNotificationId = params?.emailNotificationId
                ? '&emailNotificationId=' + params.emailNotificationId
                : ''
            const type = params?.type
                ? '&type=' + params.type
                : ''
            const fromDate = params?.fromDate
                ? '&fromDate=' + params.fromDate
                : ''
            const toDate = params?.toDate
                ? '&toDate=' + params.toDate
                : ''
            const sort = params?.sortKey
            ? '&sort=' + params.sortKey
            : ''
            const sortOrder = params?.sortOrder
            ? '&order=' + params.sortOrder
            : ''
            
            const { data } = await axios.get(
                '/api/email_notifications' + 
                    page + 
                    perPage + 
                    workspaceMemberId +
                    emailNotificationId +
                    type +
                    fromDate +
                    toDate +
                    sort +
                    sortOrder,
            )

            return data
        },
    },
}

export default notificationModule
